import { render, staticRenderFns } from "./LinkWithPlugins.vue?vue&type=template&id=0ba8d547&scoped=true"
import script from "./LinkWithPlugins.vue?vue&type=script&lang=js"
export * from "./LinkWithPlugins.vue?vue&type=script&lang=js"
import style0 from "./LinkWithPlugins.vue?vue&type=style&index=0&id=0ba8d547&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba8d547",
  null
  
)

export default component.exports